var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconHappyLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .happy-cls-1 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "happy-cls-1",
    cx: 25,
    cy: 25,
    r: 23.1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "happy-cls-1",
    points: "13.7 13.7 20.5 20.5 11.5 20.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "happy-cls-1",
    points: "36.3 13.7 29.5 20.5 38.5 20.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "happy-cls-1",
    d: "M11.8,28.4c1,6.4,6.5,11.3,13.2,11.3s12.2-4.9,13.2-11.3H11.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconHappyLine);
export default __webpack_public_path__ + "static/media/cloud_icon_happy_line.137555eebe9661e5e5700422c7da2317.svg";
export { ForwardRef as ReactComponent };